<template>
  <b-container fluid>
        <b-row>
            <b-col cols="12" md="4">
                <div class="login__description">
                    <div>
                        <h3>
                            <img :src="$cdn + '/icons/icon-person-login.svg'" alt="icono persona">
                            Registro
                        </h3>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="8">
                <div class="login__form w-100 mb-0">
                    <div class="login__paragraph">
                        <p>Para iniciar el registro adjunta tu Registro Único Tributario (RUT):</p>
                    </div>

                    <div class="labels">
                        <label>Archivo en formato pdf. Tamaño máximo 5MB</label>
                    </div>

                    <div class="boton-file">
                        <img :src="$cdn + '/icons/icon-click.svg'" alt="icono click" />
                        <b-form-file id="imagen" :class="classArchivo ? '' : 'invalid-file'" @change="subirArchivo" type="file" placeholder="Adjuntar archivo" accept=".jpg, .png, .pdf" ></b-form-file>
                    </div>
                    <div v-if="!mostrarBoton" class="login__paragraph">
                      <p>Debe adjuntar tu Registro Único Tributario (RUT) para poder Continuar.</p>
                    </div>

                    <p class="nombre_archivo" v-if="result != ''">
                      Email: {{ result.email }}<br>
                      Doc: {{ result.identificacion }}
                    </p>

                    <!--<p class="nombre_archivo" v-if="imagen != null && imagen != ''">
                        {{ imagen != null && imagen != "" ? imagen : "" }}
                        <button class="boton-eliminar" @click="borrarArchivo('1')">
                            <img :src="$cdn + '/icons/icon-trash.svg'" alt="icono caneca">
                        </button>
                    </p>-->
                </div>
                <div>
                  <div class="login__paragraph">
                    <!--<p>Autorizo de manera previa, expresa e inequívoca a CAJASAN el tratamiento de mis datos personales (o el tratamiento de los datos personales del menor de edad o persona en condición de discapacidad que represento) aquí consignados, para que sean almacenados, usados y puestos en circulación o suprimidos, conforme a la Política de Tratamiento de la Información que la Corporación ha adoptado y que se encuentra publicada en la página web www.cajasan.com que declaro conocer y por ello estar informado de la finalidades de dicho tratamiento, por estar en ella consignado.</p>-->
                    <!--<p>Al diligenciar este formulario autorizo a CAJA SANTANDEREANA DE SUBSIDIO FAMILIAR "CAJASAN", ubicada en CARRERA 27 # 61 – 78 PUERTA DEL SOL y con teléfono de contacto 6434444, para que recolecte, almacene, use, circule y/o suprima mis datos personales y los de mis representados, que se capturan en este formulario y en sus anexos, incluyendo el consentimiento para tratar datos sensibles, aun conociendo que no estoy obligado a autorizar su tratamiento. Lo anterior para dar cumplimiento a las finalidades incorporadas en la Política de Tratamiento de Información disponible en www.cajasan.com, la cual declaro conocer y saber que en esta se especifican cuáles datos son sensibles. Así mismo, conozco que como titular me asisten los derechos a conocer, actualizar, rectificar y suprimir mis datos y revocar la autorización.</p>-->
                    <p>Al diligenciar este documento autorizo a CAJA SANTANDEREANA DE SUBSIDIO FAMILIAR "CAJASAN", ubicada en CARRERA 27 # 61 – 78 PUERTA DEL SOL y con teléfono de contacto 6434444, para que recolecte, almacene, use, circule y/o suprima mis datos personales y los de mis representados, incluyendo el consentimiento para tratar datos sensibles y de menores de edad, aun conociendo que no estoy obligado a autorizar su tratamiento, lo anterior para contactarme para adelantar gestiones de cobro y/o enviar mensajes publicitarios o comerciales, a través de los canales: llamadas telefónicas, correos electrónicos, mensajes SMS, mensajes de aplicación web, correspondencia y visitas a domicilio; y en general para las demás finalidades incorporadas en la Política de Tratamientos de la Información dispuesta en www.cajasan.com, la cual declaro conocer y saber que en esta se establecen cuáles son datos sensibles. Así mismo, conozco que como titular me asisten los derechos a conocer, actualizar, rectificar y suprimir mis datos y revocar la autorización. Igualmente declaro que poseo autorización, de los otros titulares de datos que suministro, para que CAJA SANTANDEREANA DE SUBSIDIO FAMILIAR "CAJASAN" les dé tratamiento conforme a las finalidades consignadas en la Política.</p>
                    <b-form-radio-group
                        id="radio-group-1"
                        v-model="seopac"
                        :options="opacp"
                        :aria-describedby="ariaDescribedby"
                        name="radio-options"
                    ></b-form-radio-group>
                  </div>
                    <div class="login__terms">
                      <div class="term">
                        <!--<div class="input--check">
                            <input v-model="terminos" type="checkbox" value="true" id="terminos"/>
                            <label class="checkbox" for="terminos"></label>
                        </div>-->
                        <a class="m-0" href="https://cajasan.com/aviso-privacidad" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>
                      </div>
                      <div class="term">
                        <!--<div class="input--check">
                            <input v-model="politicas" type="checkbox" value="true" id="politicas"/>
                            <label class="checkbox" for="politicas"></label>
                        </div>-->
                        <a class="m-0" href="https://cajasan.com/documentos-transparencia/politica-tratamiento-de-informacion-cajasan" target="_blank" rel="noopener noreferrer">Política de Tratamiento de Datos de Cajasan</a>
                      </div>
                      <div class="term">
                        <!--<div class="input--check">
                          <input v-model="inhabilidades" type="checkbox" value="true" id="inhabilidades"/>
                          <label class="checkbox" for="inhabilidades"></label>
                        </div>-->
                        <a class="m-0" href="javascript:void(0);" @click="mostrarRegimen" rel="noopener noreferrer">Regimen de Inhabilidades e Incompatibilidades</a>
                      </div>
                    </div>
                  <!--<button v-if="mostrarBoton" class="button-principal mb-5" v-on:click="stateChange('register')">Siguiente</button>
                  <div v-else class="login__paragraph">
                    <p>Debe adjuntar tu Registro Único Tributario (RUT) para poder Continuar.</p>
                  </div>-->
                </div>
              <div class="login__paragraph">
                <p>Acepta Terminos y Condiciones, las Politicas de Tratamiento de Datos de Cajasan, y el Regimen de Inhabilidades e Incompatibilidades.</p>
              </div>
              <b-row align-content="center">
                <b-col>
                  <button class="button-principal-sw mb-5" v-on:click="stateChange('register')">Si, Acepto</button>
                </b-col>
                <b-col>
                  <button class="button-secundary mb-5" v-on:click="$router.push('/')">No, Acepto</button>
                </b-col>
              </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'formRut',
  data () {
    return {
      imagen: '',
      classArchivo: true,
      terminos: '',
      politicas: '',
      result: '',
      mostrarBoton: false,
      inhabilidades: '',
      opacp:[
        { text: 'Si autorizo', value: 1 },
        { text: 'No autorizo', value: 0 }
      ],
      seopac:0
    }
  },
  methods: {
    stateChange: function (state) {
      /*if(this.terminos == true && this.politicas == true && this.politicas == true){
        this.$emit('stateChange', state, this.result)
      }else{
        this.$swal('Debe aceptar los Terminos de uso y Politicas de Tratamiento de Datos')
      }*/
      if(this.seopac==1){
        this.$emit('stateChange', state, this.result)
      }else {
        this.$swal('Debe aceptar la autorización')
      }


    },
    subirArchivo: function () {
      this.mostrarBoton = false
      var file = $('#imagen').get(0).files[0]

         if (file) {
           if (file.size > 5000000) {
             $('#imagen').val(null)
             this.$swal('La imagen supera el máximo permitido 5MB.')
             //this.$store.commit('setMessage', { estado: true, mensaje: 'La imagen supera el máximo permitido 5MB.' })
           } else {
             var datos = {
               archivo: file
             }
             this.$store.dispatch('subirArchivo', datos).then(response => {
               this.mostrarBoton = true
               if (response.CODE === 1) {
                 this.imagen = file
                 this.result = response.RESULT
               }else{
                 this.$swal('No se pudo detectar el email y el nit, por favor haz clic en Siguiente y registralos.')
               }
             })

           }
         } else {
           $('#imagen').val(null)
         }

    },
    mostrarRegimen: function(){
      const vhtml =
        '<main class="content--modal">'+
          '<h2>REGIMEN DE INHABILIDADES E INCOMPATIBILIDADES</h2>'+
          '<p>Declaro bajo la gravedad de juramento que:</p>'+
          '<ol>'+
            '<li>No tengo la calidad de colaborador, miembro del Consejo Directivo, Director, Revisor Fiscal de CAJASAN o trabajador de Asociaciones de Cajas, ni he desempeñado alguno de estos cargos en el año inmediatamente anterior a la firma de este documento. Que tampoco actúo en nombre de las persona mencionadas.</li>'+
            '<li>Con colaboradores, miembros del Consejo Directivo, Director, Revisor Fiscal de CAJASAN o trabajadores de Asociaciones de Cajas, o personas que ostentaron estos cargos durante el año anterior a la firma de este documento, no poseo ninguno de los siguientes vínculos: cónyuge, hijo, padre, abuelo, nieto, hermano, suegro, nuera, o yerno, hijo adoptivo y/o padre o madre adoptante.</li>'+
            '<li>Con colaboradores, miembros del Consejo Directivo, Director, Revisor Fiscal de CAJASAN o trabajadores de Asociaciones de Cajas, o personas que ostentaron estos cargos durante el año anterior a la firma de este documento, no tengo asociación profesional, comunidad de oficina o sociedad de personas o limitada.</li>'+
            '<li>En nombre de la sociedad de personas, limitada o de hecho que represento, manifiesto que ningún colaborador, miembro del Consejo Directivo, Director, Revisor Fiscal de CAJASAN o trabajadores de Asociaciones de Cajas, o el cónyuge de las personas indicadas, hacen o hicieron parte de esta sociedad, en calidad de socios, durante el año anterior a la firma de este documento.</li>'+
            '<li>En caso de existir un vínculo de parentesco hasta el cuarto grado de consanguinidad, primero de afinidad y único civil (padre, hijo, abuelo, nieto, hermano, tío, sobrino, primo, suegro, nuera o yerno, hijo adoptivo y/o padre o madre adoptante) en mi calidad de contratista persona natural o de alguno de los socios o asociados de la persona jurídica que represento, con el Director Administrativo, algún miembro del Consejo Directivo o administrador, de CAJASAN, me comprometo a informarlo a fin de que ésta de aplicación a las medidas definidas por el artículo 23 de la Ley 789 de 2002 en caso de existir conflictos de interés.</li>'+
            '<li>No he sido responsable de dar por terminado contrato alguno con Cajasan por hechos irregulares</li>'+
            '<li>No encontrarme incurso en cualquier proceso relacionado con actividades ilícitas o incorporadas a listas concernientes al lavado de activos.</li>'+
          '</ol>'+
        '</main>'
      this.$swal.fire({
            html: vhtml
      }
      )

    }


    //  subirArchivo: function () {
    //    var file = $('#imagen').get(0).files[0]
    //    var datos = {
    //      archivo: file,
    //      token: this.json_usuario.token
    //    }
    //    this.$store.dispatch('subirArchivo', datos).then(response => {
    //      if (response.CODE === 1) {
    //        this.imagen = response.DATA
    //      }
    //    })
    //  },

    //  cambioArchivo: function (opc) {
    //    this['archivoLoaded' + opc] = false
    //    var file = $('#archivo' + opc).get(0).files[0]

    //    if (file) {
    //      if (file.size > 5000000) {
    //        this['classArchivo' + opc] = false
    //        this['archivoLoaded' + opc] = false
    //        $('#archivo' + opc).val(null)
    //        this.$store.commit('setMessage', { estado: true, mensaje: 'La imagen supera el máximo permitido 5MB.' })
    //      } else {
    //        this['classArchivo' + opc] = true
    //        this['archivoLoaded' + opc] = true

    //        var elements = document.getElementsByClassName('custom-file-label')

    //        Array.prototype.forEach.call(elements, function (element, index) {
    //          elements.item(index).innerHTML = 'Adjuntar archivo'
    //        })

    //        this['archivo' + opc] = file.name
    //      }
    //    } else {
    //      this['classArchivo' + opc] = false
    //      this['archivoLoaded' + opc] = false
    //      $('#archivo' + opc).val(null)
    //    }

    //    var file2 = $('#imagen').get(0).files[0]
    //    var datos = {
    //      archivo: file2,
    //      token: this.json_usuario.token
    //    }
    //    this.$store.dispatch('subirArchivo', datos).then(response => {
    //      if (response.CODE === 1) {
    //        this.imagen = response.DATA
    //      }
    //    })
    //  },

    //  borrarArchivo: function (opc) {
    //    var file = $('#archivo' + opc).get(0).files[0]

    //    if (file) {
    //      this['archivo' + opc] = ''
    //      this['classArchivo' + opc] = false
    //      this['archivoLoaded' + opc] = false
    //      $('#archivo' + opc).val(null)
    //    } else {
    //      this['archivo' + opc] = ''
    //      this['classArchivo' + opc] = false
    //      this['archivoLoaded' + opc] = false
    //      $('#archivo' + opc).val(null)
    //    }
    //  }
  }
}
</script>
